<template>
	<div :class="getInfoWindowActive()">
    <b-card no-body header-tag="header">
      <div slot="header" class="mb-0 d-flex"><div class="header">Feature Info</div><span class="ml-auto" style="margin-top:-2px;"><a class="close" href="#" @click.prevent="clearSelected()">&times;</a></span></div>
      <info-item v-for="feature,key in selected" :key="key" :index="key" :feature="feature" @highlight-feature="highlightFeature"></info-item>
    </b-card>
		<slot/>
	</div>
</template>

<script>

import InfoItem from '../Info/InfoItem.vue';

const methods = {
  highlightFeature (e){
    this.$parent.$emit("highlightFeature",e)
  },
  getInfoWindowActive(){
    if(this.selected.length){
      return "info-window active"
    }
    return "info-window"
  },
  clearSelected(){
    this.selected = []
    this.$parent.$emit("resetFeatures")
  }
}

export default {

  name: 'info-window',
  components: {InfoItem},
  methods,
  data () {
    return {
      selected:[]
    }
  },
  created () {
  },
  mounted () {
    var vm = this
    this.$parent.$on("featureSelected", (e) => {
      vm.selected.push(...e)
    })
    this.$parent.$on("clearSelected", (e) => {
      vm.selected = []
    })
  }
}
</script>

<style lang="scss" scoped>
	
</style>


// WEBPACK FOOTER //
// resources/js/map/MapComponents/Base/InfoWindow.vue